import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { Home, Receipt, Gamepad2, Sparkles, UserCircle2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { useShop } from "@/context/ShopContext";
import AppDownloadPromo from "@/components/AppDownloadPromo";

const TABS = [
  { to: "/", label: "Home", icon: Home, end: true },
  { to: "/orders", label: "Orders", icon: Receipt },
  { to: "/games", label: "Games", icon: Gamepad2 },
  { to: "/assistant", label: "Assistant", icon: Sparkles },
  { to: "/profile", label: "Account", icon: UserCircle2 },
];

export default function Layout() {
  const { shop } = useShop();
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="sticky top-0 z-40 glass border-b border-border">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 md:px-6">
          <Link to="/" className="flex items-center gap-2" data-testid="brand-logo">
            <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary text-primary-foreground font-display text-lg font-extrabold">
              G
            </div>
            <div className="leading-tight">
              <p className="font-display text-base font-bold tracking-tight">{shop?.name || "Dry Cleaners Goldys"}</p>
              <p className="hidden text-xs text-muted-foreground sm:block">{shop?.tagline || "Premium garment care"}</p>
            </div>
          </Link>
          {/* Desktop nav */}
          <nav className="hidden items-center gap-1 md:flex">
            {TABS.map((t) => (
              <NavLink
                key={t.to}
                to={t.to}
                end={t.end}
                data-testid={`nav-${t.label.toLowerCase()}`}
                className={({ isActive }) =>
                  cn(
                    "flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium transition-colors",
                    isActive ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:bg-secondary",
                  )
                }
              >
                <t.icon className="h-4 w-4" />
                {t.label}
              </NavLink>
            ))}
          </nav>
          <Link
            to="/booking"
            data-testid="header-book-cta"
            className="rounded-full bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground shadow-sm transition hover:opacity-90 md:ml-3"
          >
            Book now
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="mx-auto max-w-6xl px-4 pb-28 pt-4 md:px-6 md:pb-10" key={location.pathname}>
        <Outlet />
      </main>

      <AppDownloadPromo />

      {/* Mobile bottom tabs */}
      <nav className="fixed bottom-0 left-0 right-0 z-40 glass border-t border-border md:hidden" data-testid="bottom-tabs">
        <div className="mx-auto flex max-w-lg items-stretch justify-between px-2 py-1.5">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.end}
              data-testid={`tab-${t.label.toLowerCase()}`}
              className={({ isActive }) =>
                cn(
                  "flex flex-1 flex-col items-center gap-0.5 rounded-lg py-1.5 text-[11px] font-medium transition-colors",
                  isActive ? "text-primary" : "text-muted-foreground",
                )
              }
            >
              <t.icon className="h-5 w-5" />
              {t.label}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
